export default __webpack_public_path__ + "static/media/sectionTwoRightImg.d8f44b92.png";